import React from 'react';
import PropTypes from "prop-types";
import { Config } from '../../config/index';

const FeedMedia = (props) => {

    const text = () => {
        if (props.team !== undefined && props.team !== null && props.team.shortcut !== undefined && props.team.shortcut !== null && props.team.shortcut !== '')
        {
            return `${props.team.name} ${props.team.surname}`;
        }
        return 'France Baseball';
    };

    const imgAddress = () => {
        if (props.url !== undefined && props.url !== null && props.url !== ''){
            return props.url;
        }
        else
        {
            if (props.team !== undefined && props.team !== null && props.team.shortcut !== undefined && props.team.shortcut !== null && props.team.shortcut !== '')
            {
                return props.team.image;
            }
            return `${Config.cdn}/img/org/DEFAULT/news.png`;
        }
    };

    return (
        <a href={props.link} rel="noreferrer" target="_blank" className={props.linkClass}>
            <img src={imgAddress()} alt={text()} className={props.imgClass} />
         </a>
    );
}

/* properties :  */
FeedMedia.propTypes = {
    team: PropTypes.object,
    url: PropTypes.string,
    link: PropTypes.string,
    linkClass: PropTypes.string,
    imgClass: PropTypes.string,
};

export default FeedMedia;